import urls from "../../global/constants/UrlConstants";
import { getFileCallParams, makeCall } from "../../utils/service";

/**
 * Uploads the image/video shown beside a public form and returns its public
 * URL. Shares the generic S3 upload endpoint used elsewhere in the app.
 */
export async function uploadFormMedia(file: File): Promise<string> {
  const body = new FormData();
  body.append("file", file);
  const callParams = await getFileCallParams(body);
  const response = await makeCall(urls.UPLOADIMAGE, callParams);
  const url = response?.imageUrl || response?.data?.imageUrl || "";
  if (!url) throw new Error("Upload did not return a file URL");
  return String(url);
}
